import Vue from 'vue';

const tasksModule = {
  state: {
    tasksCount: 0,
  },

  getters: {
    tasksCount: (state) => state.tasksCount,
  },

  mutations: {
    SET_TASKS_COUNT: (state, count) => {
      Vue.set(state, 'tasksCount', count);
    },
  },

  actions: {
    getTasksCount(context, { len }) {
      context.commit('SET_TASKS_COUNT', { len });
    },
  },
};

export default tasksModule;
